import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http'
import { inject } from '@angular/core'
import { LoaderService } from '@services'
import { Observable, finalize } from 'rxjs'

const excludedRoutes: RegExp[] = [
	/i18n/,
	/validation\/mail/,
	/\/tax-validator/,
	/\/google-maps\/places/,
	/\/documents\/documents\/\d+/,
	/documents\/upload/,
	/\/stats\/summary/,
	/\/stats\/subscriptions\/renewals(\/monthly)?/,
	/\/stats\/subscriptions\/cancellations(\/monthly)?/,
	/\/stats\/subscriptions\/signups(\/monthly)?/,
	/\/stats\/subscriptions\/plan-changes/,
	/\/stats\/subscriptions\/revenue(\/monthly)?/,
	/\/stats\/subscriptions\/annual-totals/,
	/\/stats\/subscriptions\/income-breakdown/,
	/\/stats\/subscriptions\/report-snapshot(?:\/(?:income|refresh))?(?:\?|$)/
]
let requestCount = 0

export const loaderInterceptor: HttpInterceptorFn = (
	request: HttpRequest<unknown>,
	next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
	const loaderService = inject(LoaderService)

	if (excludedRoutes.some(route => request.url.match(route))) {
		return next(request)
	}

	requestCount++

	setTimeout(() => {
		if (requestCount) loaderService.showLoading()
	}, 800)

	return next(request).pipe(
		finalize(() => {
			requestCount--

			if (requestCount === 0) {
				loaderService.hideLoading()
			}
		})
	)
}
